import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const translations = {
  de: {
    title: 'Erfolgreich abgemeldet',
    message: 'Sie wurden erfolgreich von unserer Mailingliste abgemeldet.',
    note: 'Sie erhalten keine weiteren E-Mails von uns.'
  },
  fr: {
    title: 'Désabonnement réussi',
    message: 'Vous avez été désabonné avec succès de notre liste de diffusion.',
    note: 'Vous ne recevrez plus d\'e-mails de notre part.'
  },
  it: {
    title: 'Cancellazione riuscita',
    message: 'Sei stato cancellato con successo dalla nostra mailing list.',
    note: 'Non riceverai più email da noi.'
  },
  en: {
    title: 'Successfully Unsubscribed',
    message: 'You have been successfully unsubscribed from our mailing list.',
    note: 'You will no longer receive emails from us.'
  }
};

const UnsubscribeConfirm = () => {
  const [searchParams] = useSearchParams();
  const [language, setLanguage] = useState(searchParams.get('lang') || 'de');

  useEffect(() => {
    if (!searchParams.get('lang')) {
      const browserLang = navigator.language.split('-')[0];
      if (['de', 'fr', 'it'].includes(browserLang)) {
        setLanguage(browserLang);
      }
    }
  }, [searchParams]);

  const t = translations[language] || translations.en;

  return (
    <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_mailcraft-13/artifacts/hs5d8bkj_dommo_logo.png" 
            alt="Dommo Logo" 
            className="h-16 w-16 mx-auto mb-4 object-contain"
          />
          <h1 className="text-3xl font-bold tracking-tight text-[#183871] mb-2">
            Dommo Swiss Mailer
          </h1>
        </div>

        {/* Confirmation Card */}
        <div className="rounded-lg border border-[#2A2D36] bg-[#13151A]/80 backdrop-blur-sm p-8 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.5)] text-center">
          <div className="flex items-center justify-center mb-6">
            <CheckCircle size={64} className="text-[#10B981]" strokeWidth={1.5} />
          </div>

          <h2 className="text-2xl font-bold text-[#F3F4F6] mb-4">
            {t.title}
          </h2>

          <p className="text-[#9CA3AF] mb-4">
            {t.message}
          </p>

          <div className="p-4 rounded-md bg-[#10B981]/10 border border-[#10B981]/20">
            <p className="text-sm text-[#9CA3AF]">
              {t.note}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribeConfirm;
